class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();

    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    // Initialize when DOM is ready
    this.initializeWhenReady();
  }

  initializeWhenReady() {
    // Use setTimeout to ensure DOM is fully rendered
    setTimeout(() => {
      const facetForm = this.querySelector('form');
      if (facetForm) {
        facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
      }

      // Add event listener for sort dropdown - check all possible selectors
      const sortSelect = this.querySelector('#SortBy') || this.querySelector('select[name="sort_by"]');
      if (sortSelect) {
        sortSelect.addEventListener('change', this.debouncedOnSubmit.bind(this));
      }

      const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
      if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    }, 100);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);

    // Also initialize any sort dropdowns that might exist globally
    document.addEventListener('DOMContentLoaded', () => {
      FacetFiltersForm.initializeGlobalSortListeners();
    });

    // Fallback initialization after a delay
    setTimeout(() => {
      FacetFiltersForm.initializeGlobalSortListeners();
    }, 1000);
  }

  static initializeGlobalSortListeners() {
    // Find all sort dropdowns and ensure they have event listeners
    const allSortSelects = document.querySelectorAll('#SortBy, select[name="sort_by"]');
    allSortSelects.forEach(select => {
      // Remove existing listener to avoid duplicates
      select.removeEventListener('change', FacetFiltersForm.handleSortChange);
      // Add the listener
      select.addEventListener('change', FacetFiltersForm.handleSortChange);
    });
  }

  static handleSortChange(event) {
    const facetForm = event.target.closest('facet-filters-form');
    if (facetForm) {
      facetForm.debouncedOnSubmit(event);
    } else {
      // Fallback: trigger submission on any facet form
      const anyFacetForm = document.querySelector('facet-filters-form');
      if (anyFacetForm) {
        anyFacetForm.debouncedOnSubmit(event);
      }
    }
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');

    document.getElementById('ProductGridContainer').querySelector('.collection-grid-container').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        
        // Re-initialize sort listeners after rendering
        setTimeout(() => {
          FacetFiltersForm.initializeGlobalSortListeners();
        }, 100);
        /// Ensure sort dropdown reflects current URL/default
setTimeout(() => {
  try {
var current = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
    document.querySelectorAll('#SortBy, select[name="sort_by"]').forEach(sel => {
      if (sel && sel.value !== current) {
        // Only set if that option exists
        if ([...sel.options].some(o => o.value === current)) {
          sel.value = current;
        }
      }
    });
  } catch (e) {}
}, 150);


        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    
    // Re-initialize sort listeners after rendering
    setTimeout(() => {
      FacetFiltersForm.initializeGlobalSortListeners();
    }, 100);// Ensure sort dropdown reflects current URL/default
setTimeout(() => {
  try {
var current = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
    document.querySelectorAll('#SortBy, select[name="sort_by"]').forEach(sel => {
      if (sel && sel.value !== current) {
        // Only set if that option exists
        if ([...sel.options].some(o => o.value === current)) {
          sel.value = current;
        }
      }
    });
  } catch (e) {}
}, 150);


    
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
    const facetDetailsElementsFromDom = document.querySelectorAll('#FacetFiltersForm .js-filter');

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementToActivate = newFacetDetailsElement.querySelector('.facets__summary');

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();

    const params = new URLSearchParams();

    // Handle sort_by parameter with multiple fallbacks
    let sortValue = null;
    
    // Priority 1: Direct event target
    if (event.target && (event.target.name === 'sort_by' || event.target.id === 'SortBy')) {
      sortValue = event.target.value;
    }
    
    // Priority 2: Find any sort select on page
    if (!sortValue) {
      const sortSelects = document.querySelectorAll('#SortBy, select[name="sort_by"]');
      for (let select of sortSelects) {
        if (select.value) {
          sortValue = select.value;
          break;
        }
      }
    }
    
    // Priority 3: URL parameter
if (!sortValue) {
  const currentUrl = new URL(window.location.href);
  sortValue = currentUrl.searchParams.get('sort_by');
}

// Priority 4: Hard default to newest → oldest
if (!sortValue) {
sortValue = 'manual';
}

if (sortValue) {
  params.set('sort_by', sortValue);
}


    // Get all facet filter forms
    const facetFilterForms = document.querySelectorAll('facet-filters-form form');

    facetFilterForms.forEach((form) => {
      const formData = new FormData(form);
      
      for (let [name, value] of formData.entries()) {
        if (name === 'sort_by') {
          if (!params.has('sort_by')) {
            params.set('sort_by', value);
          }
        } else if (value && value.trim() !== '') {
          if (params.has(name)) {
            const existingValue = params.get(name);
            if (existingValue !== value) {
              params.append(name, value);
            }
          } else {
            params.set(name, value);
          }
        }
      }
    });

    this.onSubmitForm(params.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
// Sync sort dropdown on initial load
(function syncSortDropdownInitially(){
  try {
var current = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll('#SortBy, select[name="sort_by"]').forEach(sel => {
        if (sel && sel.value !== current && [...sel.options].some(o => o.value === current)) {
          sel.value = current;
        }
      });
    });
  } catch (e) {}
})();

// --- Force default sort on initial load across ALL collections ---
(function enforceDefaultSortOnLoad() {
  try {
    // Only run on pages that have a collection grid
    if (!document.getElementById('ProductGridContainer')) return;

    var url = new URL(window.location.href);
    if (!url.searchParams.get('sort_by')) {
url.searchParams.set('sort_by', 'manual');
      // Prefer AJAX render if section exists to avoid hard reload
      var qs = url.search.slice(1);
      if (typeof FacetFiltersForm !== 'undefined') {
        FacetFiltersForm.updateURLHash(qs);
        FacetFiltersForm.renderPage(qs, null, false);
      } else {
        window.location.replace(url.toString());
      }
    }
  } catch (e) { /* no-op */ }
})();


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Delete', 'Escape'];
    if (!allowedKeys.includes(event.key) && !/[0-9.,]/.test(event.key)) {
      event.preventDefault();
    }
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];

    if (maxInput.value) {
      minInput.setAttribute('data-max', maxInput.value);
    } else {
      minInput.setAttribute('data-max', maxInput.getAttribute('max'));
    }

    if (minInput.value) {
      maxInput.setAttribute('data-min', minInput.value);
    } else {
      maxInput.setAttribute('data-min', minInput.getAttribute('min'));
    }
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min')) || 0;
    const max = Number(input.getAttribute('max'));

    if (!isNaN(min) && value < min) input.value = min;
    if (!isNaN(max) && value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);